<template>
  <div class="case_box" v-if="detailList">
    <ul>
      <li v-for="(v,ind) in inf" :key="ind">
        <span v-if="v.flag" class="btn_box" :class="{'blue':v.url}" @click="tourl(v.url)">
          {{v.url?v.data:'无'}}
        </span>
        <span v-else>
          {{v}}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
  import langtrans from "./js/parheader.vue.trans.js";
  import qs from "qs";
  import constants from '@/util/constants.js';
  export default {
    props: ["caseid", 'detailList'],
    data() {
      return {
        inf: {},
        casenumber: "",
        usertype: JSON.parse(window.localStorage.getItem("usertype")).data,
        token: JSON.parse(window.localStorage.getItem('data')).data,
      }
    },
    computed: {
      languageIndex() {
        return this.$store.state.language
      }
    },
    methods: {
      langtrans() {
        return langtrans
      },

      tourl(url) {
        if (url != "") {
          window.open(url);
        }
      },
      getDetail() {
        if(this.detailList.obj.obj.incidentType == '' ) return
        this.casenumber = this.detailList.obj.obj.caseNo;
        let o = this.detailList.obj.obj;
        let victimList = this.detailList.obj.victimList[0].obj;
        let reportUser = o.reportUser || "";
        let reportPhone = o.reporterContact || "";
        let victimName = victimList.victimName || "";
        var exp = ''
        if (o.caseSrcDesc) {
          if (!constants.setTxt(o.caseSrcDesc, 'zh')) {
            exp = this.langtrans().lyssym[this.languageIndex] + o.caseSrcDesc
          } else {
            exp = this.langtrans().lyssym[this.languageIndex] + constants.setTxt(o.caseSrcDesc, 'zh')
          }
        } else {
          exp = this.langtrans().lyssym[this.languageIndex] + '无'
        }
        // console.log(,this.caseid)
        if(this.detailList.obj.obj.incidentType != 800) {
            this.inf = {
          time: this.langtrans().basjj[this.languageIndex] + constants.time(o.reportTs),
          user: this.langtrans().bakh[this.languageIndex] + reportUser,
          person: this.langtrans().cxrxm[this.languageIndex] + victimName,
          phone: this.langtrans().badh[this.languageIndex] + reportPhone,
          instime: this.langtrans().cxsjj[this.languageIndex] + constants.time(o.incidentTs),
          sex: this.langtrans().xbbn[this.languageIndex] + (victimList.gender == '1' ? this.langtrans().nan[this.languageIndex] :
            this.langtrans().nv[this.languageIndex]),
          // null: "-",
          card: this.langtrans().zjhhm[this.languageIndex] + (victimList.idNo || ""),
          number: this.langtrans().bdcshh[this.languageIndex] + (victimList.insurancePolicyNo || ""),
          pardata: {
            flag: true,
            data: this.langtrans().bdcsxq[this.languageIndex],
            url: (victimList.insurancePaper || "")
          },
          belong: this.langtrans().sszbxg[this.languageIndex] + (this.detailList.obj.victimList[0].insuranceCompany || ""),
          source: this.langtrans().ajxsxx[this.languageIndex] + (o.caseSrc || ""),
          exp
        };
        if(this.detailList.obj.obj.incidentType == 900) {
          this.inf.source = '报案方式：'+ (o.caseSrc || "")
        }
        
        }else {
           this.inf = {
          time: this.langtrans().basjj[this.languageIndex] + constants.time(o.reportTs),
          user: this.langtrans().bakh[this.languageIndex] + reportUser,
          person: '被保险人：' + victimName,
          phone: this.langtrans().badh[this.languageIndex] + reportPhone,
          instime: '预期服务时间：' + constants.time(o.incidentTs),
          sex: this.langtrans().xbbn[this.languageIndex] + (victimList.gender == '1' ? this.langtrans().nan[this.languageIndex] :
            this.langtrans().nv[this.languageIndex]),
          // null: "-",
         
          card: '被保人证件：' + (victimList.idNo || ""),
          number: this.langtrans().bdcshh[this.languageIndex] + (victimList.insurancePolicyNo || ""),
          pardata: {
            flag: true,
            data: this.langtrans().bdcsxq[this.languageIndex],
            url: (victimList.insurancePaper || "")
          },
          belong: this.langtrans().sszbxg[this.languageIndex] + (this.detailList.obj.victimList[0].insuranceCompany || ""),
          source: this.langtrans().ajxsxx[this.languageIndex] + (o.caseSrc || ""),
           
          exp
          
        };
         
        if(victimList.gender == null) {
          this.inf.sex = this.langtrans().xbbn[this.languageIndex] + '-'
        }
        }
       
        console.log(this.inf);
      }
    },

    mounted() {
      this.getDetail()
    },
    watch: {
      languageIndex() {
        this.getDetail()
      },
      '$route.query.caseid'() {
        this.getDetail();
      },
      detailList(){
        this.getDetail()
      }
    }

  };
</script>
<style scoped>
  .case_box {
    width: auto;
  }

  .case_box p {
    line-height: 40px;
  }

  .case_box p span {
    margin-left: 1.25vw;
  }

  .case_box ul {
    overflow: hidden;
    border-left: 1px solid #d9ddde;
    border-top: 1px solid #d9ddde;
    box-sizing: content-box;
  }

  .case_box ul li {
    line-height: 40px;
    float: left;
    border-bottom: 1px solid #d9ddde;
    border-right: 1px solid #d9ddde;
    padding: 0 5px;
    width: calc(33.3% - 11px);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
  }

  .blue {
    color: #11b0fa;
  }
</style>



// WEBPACK FOOTER //
// src/views/commonPage/details/parheader.vue